"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilIconHelp = void 0;
var react_1 = __importDefault(require("react"));
var IconBase_1 = __importDefault(require("../IconBase"));
var utils_1 = require("../utils");
var AlertQuestion = function (props) { return (react_1.default.createElement(IconBase_1.default, __assign({}, props),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13 17C13 16.45 12.55 16 12 16C11.45 16 11 16.45 11 17C11 17.55 11.45 18 12 18C12.55 18 13 17.55 13 17ZM10.6 13.2V14.85H11.8C14.35 14.85 16.35 12.9 16.35 10.4C16.35 7.90001 14.35 5.95001 11.8 5.95001C9.24999 5.95001 7.29999 7.90001 7.29999 10.4H9.09999C9.09999 8.80001 10.25 7.60001 11.85 7.60001C13.45 7.60001 14.6 8.80001 14.6 10.4C14.6 12 13.45 13.2 11.85 13.2H10.6Z" }))); };
exports.UtilIconHelp = (0, utils_1.withDeprecationWarning)(AlertQuestion, 'UtilIconHelp');
exports.default = AlertQuestion;
